import { render } from "./WSNotify.vue?vue&type=template&id=6f4f612c&scoped=true&ts=true"
import script from "./WSNotify.vue?vue&type=script&lang=ts"
export * from "./WSNotify.vue?vue&type=script&lang=ts"

import "./WSNotify.vue?vue&type=style&index=0&id=6f4f612c&scoped=true&lang=css"

import exportComponent from "/home/forge/crm.thebcr.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f4f612c"]])

export default __exports__